<template>
  <div class="ps-chat-log">
    <PerfectScrollbar ref="refChatPS" :options="perfectScrollbarOptions" style="height: 100%" @ps-scroll-y="onScroll">
      <div class="chat-log">
        <!-- Loading -->
        <div class="text-center mt-2" v-show="isLoadingPrevPage">
          <v-progress-circular indeterminate color="primary"></v-progress-circular>
        </div>
        <div class="text-center mt-2" v-show="isLoadingData">
          <v-progress-circular indeterminate color="primary" style="margin-right: 10px;"></v-progress-circular>
          {{ chatLoadingText }}
        </div>
        <!-- 消息列表 -->
        <div v-for="(message, index) in messageList" :key="message.Id" class="d-flex align-start mb-2" :class="[{ 'flex-row-reverse': isSelf(message) }]">
          <!-- user message -->
          <div v-if="isSelf(message) && message.Text != ''" class="chat-body d-inline-flex flex-column mx-2 align-end">
            <div style="width: 100%; background-color: rgb(244 244 244);" class="chat-content mt-1 pt-2 px-2 elevation-1 chat-right  black--text">
              <!-- 文本，气泡 -->
              <p v-if="message.Type != '1' && message.Type != '2' && message.Type != '7' && message.Type != '8' && message.Type != '9'  && (!showBlinkCursor || index != messageList.length - 1)"
                style="width: 100%; font-size: 14px; line-height: 1.6" v-html="formatMessage(true ,message.ViewText)" />
            </div>
          </div>
          <!-- ai message and other message -->
          <div v-if="!isSelf(message)" class="chat-body d-inline-flex flex-column mx-2 align-start">
            <div v-if="message.Text != ''" style="width: 100%; background-color: rgb(244 244 244);" class="chat-content mt-1 pt-2 px-2 elevation-1 chat-left white black--text">
              <!-- 文本，气泡 -->
              <p v-if="message.Type != '1' && message.Type != '2' && message.Type != '7' && message.Type != '8' && message.Type != '9'  && (!showBlinkCursor || index != messageList.length - 1)"
                style="width: 100%; font-size: 14px; line-height: 1.6" v-html="formatMessage(false, message.ViewText)" />

              <!-- 欢迎语，带有操作工具条的消息卡片-->
              <div v-if="message.Type == '7'" style="width: 100%; padding-bottom: 10px;">
                <div style="font-size: 13.5px;">{{ message.ViewText }}</div>
                <div v-if="message.showBtn" style="max-width: 114% ;text-overflow: ellipsis; margin-top: 10px;"
                  class="islink" @click="gotoWeb(message.Link)">
                  {{ message.Link }}
                </div>
                <!-- 工具条 -->
                <v-chip color="primary" dark outlined label @click="updateTaskStatusofWholeSlides()"
                  style="height: 30px; width: 80%; font-size: 13.5px; margin-top: 10px;">
                  <v-icon left size="22"> mdi-microsoft-powerpoint </v-icon>
                  {{ message.action1_text }}
                </v-chip>
                <v-chip color="primary" dark outlined label @click="updateTaskStatusofOutline()"
                  style="height: 30px; width: 80%; font-size: 13.5px; color: black; margin-top: 8px;">
                  <v-icon left size="22"> mdi-format-line-weight </v-icon>
                  {{ message.action3_text }}
                </v-chip>
                <v-chip color="primary" dark outlined label @click="updateTaskStatusofOnePage()"
                  style="height: 30px; width: 80%; font-size: 13.5px; color: black; margin-top: 8px;">
                  <v-icon left size="22"> mdi-file-powerpoint-outline </v-icon>
                  {{ message.action2_text }}
                </v-chip>
                <input ref="refFileInput" type="file" @change="handleFileChange" style="display: none" />
                <v-chip color="primary" dark outlined label @click="updateTaskStatusofSlidesfromFiile()"
                  style="height: 30px; width: 80%; font-size: 13.5px; color: black; margin-top: 8px;">
                  <v-icon left size="22"> mdi-file-document-plus-outline </v-icon>
                  {{ message.action4_text }}
                </v-chip>
                <v-chip color="primary" dark outlined label @click="updateTaskStatusofWholeTemplateSlides()"
                  style="height: 30px; width: 80%; font-size: 13.5px; margin-top: 10px;">
                  <v-icon left size="22"> mdi-air-filter </v-icon>
                  {{ message.action0_text }}
                </v-chip>
              </div>

              <!-- Enhance Prompt -->
              <div v-if="message.Type == '8' && !isEnchancePromptFailure" style="width: 100%" class="chat-content elevation-1 chat-left task-left-border white black--text">
                <EnhancePromotMsgItem :items="parseViewText(message.ViewText)" @showDetail="clickShowDetail(index)" @confirm="(selectedItem) => enhancePromptConfirm(selectedItem)" />
              </div>

              <!-- message action bar -->
              <div
                v-if="!isSelf(message) && message.Type != '7' && message.Type != '8' && message.Type != '9' && !message.isGenerating && !message.Text.includes(llm_error_message)"
                class="d-flex" style="width: 100%; margin-left: auto; margin-bottom: 6px; ">
                <div class="d-flex" style="margin-top: 3px;">
                  <!-- action insert -->
                  <v-chip v-if="isGeneralMsg(message)" color="primary" dark outlined label
                    @click="insert(message.ViewText)" style="height: 22px; font-size: 13px;">
                    <v-icon left size="14"> mdi-arrow-left-top </v-icon>
                    {{ $i18n.t("chat.message_action_insert") }}
                  </v-chip>

                  <!-- action optimize -->
                  <v-chip v-if="isGeneralMsg(message)" color="primary" dark outlined label
                    @click="optimize(message.ViewText, false)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-auto-fix </v-icon>
                    {{ $i18n.t("chat.message_action_go_to_optimize") }}
                  </v-chip>
                  
                  <!-- action change template regenerate -->
                  <v-chip v-if="isWholePPTMsg(message)" color="primary" dark outlined label
                    @click="reCreatePPT(message)" style="height: 22px; font-size: 13px;">
                    <v-icon left size="14"> mdi-swap-vertical </v-icon>
                    {{ $t("chat.message_action_change_template_regenerate") }}
                  </v-chip>
                  
                  <!-- action optimize -->
                  <v-chip v-if="isWholePPTMsg(message)" color="primary" dark outlined label
                    @click="optimize(message.Detail, true)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-auto-fix </v-icon>
                    {{ $i18n.t("chat.message_action_go_to_optimize") }}
                  </v-chip>
                  
                  <!-- action msg detail -->
                  <v-chip v-if="isTranslateAllMsg(message)" color="primary" dark outlined label
                    @click="showTranslateDetail(message)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-auto-fix </v-icon>
                    {{ $i18n.t("chat.message_action_go_to_details") }}
                  </v-chip>
                  
                  <!-- action onepage chage template regenerate -->
                  <v-chip v-if="isOnePageSlide(message)" color="primary" dark outlined label
                    @click="reCreateOnePageSlide(message)" style="height: 22px; font-size: 13px;">
                    <v-icon left size="14"> mdi-swap-vertical </v-icon>
                    {{ $i18n.t("chat.message_action_change_template_regenerate") }}
                  </v-chip>

                  <!-- action msg detail -->
                  <v-chip v-if="isOnePageSlide(message)" color="primary" dark outlined label
                    @click="showOnePageSlideDialog(message)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-auto-fix </v-icon>
                    {{ $i18n.t("chat.message_action_go_to_details") }}
                  </v-chip>

                  <!-- action outline generate ppt -->
                  <v-chip v-if="isOutlineMessage(message)" color="primary" dark outlined label
                    @click="generateOutlinePPT(message.ViewText)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-file-powerpoint-outline </v-icon>
                    {{ $i18n.t("chat.message_action_outline_ppt") }}
                  </v-chip>

                  <!-- action outline optimize -->
                  <v-chip v-if="isOutlineMessage(message)" color="primary" dark outlined label
                    @click="showOutlineDialog(message.ViewText)" style="height: 22px; font-size: 13px; margin-left: 5px; ">
                    <v-icon left size="14"> mdi-auto-fix </v-icon>
                    {{ $i18n.t("chat.message_action_outline_optimize") }}
                  </v-chip>
                </div>
                <div class="d-flex" style="margin-left: auto">
                  <!-- action copy -->
                  <v-btn v-if="!isTranslateAllMsg(message)" icon small color="gray" @click="copy(message.ViewText)">
                    <v-icon small> mdi-clipboard-multiple-outline </v-icon>
                  </v-btn>
                  <v-btn icon small color="gray" :loading="isInScoringQueue(message)"
                    :disabled="isInScoringQueue(message)" @click="onClickThumbUp(message)">
                    <v-icon small v-if="isScored(message)"> mdi-thumb-up </v-icon>
                    <v-icon small v-else> mdi-thumb-up-outline </v-icon>
                  </v-btn>
                </div>
              </div>
              
              <!-- 订阅失效，带有操作工具条的消息卡片-->
              <div v-if="message.Type == '9'" style="width: 100%; padding-bottom: 10px;">
                <div style="font-size: 13.5px;">当前无可用额度，请升级订阅</div>
                <!-- <div v-if="message.showBtn" style="max-width: 114% ;text-overflow: ellipsis; margin-top: 10px;"
                  class="islink" @click="gotoWeb(message.Link)">
                  {{ message.Link }}
                </div> -->
                <!-- 工具条 -->
                <v-chip color="primary" dark outlined label @click="upgrade()"
                  style="height: 30px; width: 80%; font-size: 13.5px; margin-top: 10px;">
                  <v-icon left size="20"> mdi-star-four-points-outline </v-icon>
                  {{ message.action_text }}
                </v-chip>
              </div>
            </div>
            <span v-if="showBlinkCursor && index == messageList.length - 1" class="loading-text">{{ blinkText }}<span v-if="!showBlinkCursor1 && !showBlinkCursor2" class="dot-flashing"></span></span>
            <span v-if="showBlinkCursor1 && index == messageList.length - 1" class="loading-text">{{ blinkText1 }}<span v-if="!showBlinkCursor2" class="dot-flashing"></span></span>
            <span v-if="showBlinkCursor2 && index == messageList.length - 1" class="loading-text">{{ blinkText2 }}<span class="dot-flashing"></span></span>
            <!-- 文字 -->
            <div v-if="message.Type == '1'" style="width: 100%"
              class="chat-content mt-2 py-3 px-4 elevation-1 chat-left task-left-border lightgrey black--text">
              <div class="point" style="line-height: 30px" v-for="(item, index) in message.Text.Attachments[0].Items"
                :key="index" @click="gettextlist(item)">
                <div :class="item.Type == 'Link' ? 'islink' : ''">
                  {{ item.ViewText }}
                </div>
                <div v-if="item.Type == 'Style'" style="height: 30px"></div>
              </div>
            </div>
            <!-- 图片 -->
            <div v-if="message.Type == '2'"
              class="chat-content py-1 px-1 elevation-1 chat-left-border task-left-border lightgrey black--text">
              <!-- <div class="point" style="line-height: 30px"> -->
              <v-img v-if="message.ImageUrl" style="width: 200px;height: 200px;" :src="message.ImageUrl"
                @click="previewImg(message.ImageUrl)"></v-img>
              <v-icon v-else style="width: 200px;height: 200px;" x-large>mdi-alert-circle-outline</v-icon>
              <!-- </div> -->
              <div
                v-if="!isSelf(message) && message.Type != '7' && !message.isGenerating && !message.Text.includes(llm_error_message)"
                class="d-flex" style="width: 100%; margin-left: auto; ">
                <div class="d-flex" style="margin-top: 3px;">
                  <v-chip v-if="isImgMsg(message)" color="primary" dark outlined label
                    @click="insertImage(message.ImageUrl)" style="height: 22px; font-size: 13px;">
                    <v-icon left size="14"> mdi-arrow-left-top </v-icon>
                    {{ $i18n.t("chat.message_action_insert") }}
                  </v-chip>
                </div>
                <div style="margin-top: 5px; margin-left: 10px; font-size: 13px; color: gray;">{{ message.Style }}</div>
                <div class="d-flex" style="margin-left: auto">
                  <!-- <v-btn icon small color="primary" @click="copyImage(message.ImageUrl)">
                    <v-icon small> mdi-clipboard-multiple-outline </v-icon>
                  </v-btn> -->
                  <v-btn icon small color="gray" :loading="isInScoringQueue(message)"
                    :disabled="isInScoringQueue(message)" @click="onClickThumbUp(message)">
                    <v-icon small v-if="isScored(message)"> mdi-thumb-up </v-icon>
                    <v-icon small v-else> mdi-thumb-up-outline </v-icon>
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="shownodata" style="height: 100%; display: flex">
          <div style="align-self: center; width: 100%">
            <div style="width: 60px; height: 60px; margin: 0 auto">
              <img src="@/assets/common/icon_no_data.png" style="height: 100%; width: 100%" alt="" />
            </div>
            <div style="
                width: 100%;
                text-align: center;
                margin-top: 20px;
                font-size: 13px;
              ">
            </div>
          </div>
        </div>
      </div>
    </PerfectScrollbar>

    <v-dialog v-model="dialog" persistent>
      <div class="card" style="width: 100%;">
        <div class="d-flex align-center mt-2 mb-2" style="justify-content: space-between;">
          <div class="d-flex align-center">
            <v-img :src="require('../../img/icons-write.png')" max-height="24px" max-width="24px" alt="logo"
              contain></v-img>
            <div style="margin-left: 10px;">
              {{ $i18n.t("chat.text_slide_outline_title") }}
            </div>
          </div>
          <button style="margin-left: 5px;" @click="closeSlideOutline()">
            <!-- <v-icon>mdi-dots-vertical</v-icon> -->
            <v-icon>mdi-close-circle-outline</v-icon>
          </button>
        </div>
        <div>
          <v-textarea :value="outlineOptimize.resourceContent" counter
            :placeholder="$t(optimize.placeholder)" v-model="outlineOptimize.resourceContent" solo :rows="$t(rows)"
            background-color="rgb(251,255,242)" style="font-size: 13px"></v-textarea>
        </div>
        <div v-if="outlineContentArr.length > 1" style="margin-top: -20px;display: flex; justify-content: flex-start; ">
          <button style="" @click="outlineArrGoback()">
            <v-icon color="rgb(0,0,0)" size="24">mdi-chevron-left</v-icon>
          </button>
          <!-- <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_outline_to_slide") }}</div> -->
          <div style="margin-left: 5px">{{ currentOutlineIndex }}</div>
          <div style="margin-left: 5px">/</div>
          <div style="margin-left: 5px">{{ outlineContentArr.length }}</div>
          <button style="" @click="outlineArrGonext()">
            <v-icon color="rgb(0,0,0)" size="24">mdi-chevron-right</v-icon>
          </button>
        </div>
        <div style="font-size: 14px; color: gray; margin-top: 10px;">
          {{ $i18n.t("optimize_home.text_input_outline_title") }}
          <v-textarea ref="refDemandTextArea" v-model="outlineOptimize.demandText" :disabled="false"
            :placeholder="$i18n.t('optimize_home.text_input_placeholder_outline')" solo rows="2"
            style="font-size: 14px;" background-color="rgb(255, 255, 255)" @keydown.enter.stop="sendPrompt"
            no-resize></v-textarea>
        </div>
        <div v-show="!isOutlineOptimizeLoading" style="margin-top: -15px;">
          <div class="d-flex align-center">
            <!-- replace -->
            <button class="generatebtn" style="width: 100px ;background-color: rgb(68,126,35);"
              @click="generateOutlinePPT(outlineOptimize.resourceContent)">
              <v-icon color="rgb(255,255,255)" size="15">mdi-file-powerpoint-outline</v-icon>
              <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_outline_to_slide") }}</div>
            </button>
            <!-- keep -->
            <button class="generatebtn" @click="reGenerateOutline()" style="width: 100px ;margin-left: 6px;">
              <v-icon color="rgb(255,255,255)" size="15">mdi-reload</v-icon>
              <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_outline_optimize") }}</div>
            </button>
            <!-- regenerate -->
            <!-- <button class="generatebtn" style="margin-left: 6px; background-color: rgb(128,128,128);" @click="reGenerate(optimize.inputText)">
                    <v-icon color="rgb(255,255,255)" size="15">mdi-refresh</v-icon>
                    <div style="margin-left: 5px">{{ $i18n.t("optimize_home.btn_text_regenerate") }}</div>
                  </button> -->
            <!-- adjust -->
            <!-- <button class="generatebtn" @click="menuControl"
              style="margin-left: 6px; background-color: rgb(123,180,96);">
              <div style="margin-left: 5px;">{{ $i18n.t("optimize_home.btn_text_adjust") }}</div>
              <v-icon ref="adjustThanks" size="18">mdi-chevron-up</v-icon>
            </button> -->
            <!-- adjust menu -->
            <!-- <ActionMenu ref="refTaskTypeMenu" @onClickMenu="onClickMenu" @clearInput="clearInput" /> -->
          </div>
          <div class="generatewarning">{{ $i18n.t("optimize_home.text_warning_ai") }}</div>
        </div>
        <div v-show="isOutlineOptimizeLoading" style="margin-top: -15px;">
          <GenerateProcessing />
        </div>
      </div>
      <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="hideOutlineDialog()">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="form()">
            确认
          </v-btn>
        </v-card-actions> -->
      <!-- </v-card> -->
    </v-dialog>
    <v-dialog v-model="translateDetailDialog" persistent>
      <div class="card" style="width: 100%;">
        <div class="d-flex align-center mt-2 mb-2" style="justify-content: space-between;">
          <div class="d-flex align-center">
            <v-img :src="require('../../img/icons-write.png')" max-height="24px" max-width="24px" alt="logo"
              contain></v-img>
            <div style="margin-left: 10px;">
                {{ $i18n.t('ppt_addin.dialog.translate_all_title') }}
            </div>
          </div>
          <button style="margin-left: 5px;" @click="closeTranslateDialog()">
            <v-icon>mdi-close-circle-outline</v-icon>
          </button>
        </div>
        <div>
          <v-textarea ref="refInputTextArea" :value="translateDetail" counter
            :placeholder="$t(optimize.placeholder)" v-model="translateDetail" solo :rows="$t(rows)"
            background-color="rgb(251,255,242)" style="font-size: 13px"></v-textarea>
        </div>
      </div>
    </v-dialog>
    <OnepageSlideDetailDialog ref="refOnepageSlideDetailDialog" :translateDetail="onePageSlideDataString" />
  </div>
</template>

<script>
// 这里可以导入其他文件(比如:其他组件,工具JS,json文件,图文件等等)
import store from "@store";
import { get, sync } from "vuex-pathify";
import MarkdownIt from 'markdown-it'

// import { getCurrentUserAvatar, getServiceWindowAvatar } from "@/service/wd_service_com.js";
import {
  UUID,
  isEqualGuidString,
  isEmptyGuidStr,
  convertLineBreakSymbol,
  convertLineBreakSymbolReverse,
  lineBreakSymbol,
  markdownSymbol,
  jsonBreakSymbol,
  clearNotJsonBreakSymbol,
  removeBeforeFirstBracket,
  clearLineBreakSymbol
} from "@/utils/wd_utils.js";

import { d_localDateString } from "@/utils/wd_date_convert.js";

// Pubsub
// Pub
import { aisaPubIds, gptPubIds, actionMenuPubIds } from "@/service/wd_pubsub_config.js";
import { publish } from "@/service/wd_pubsub.js";
import { subscribe, unsubscribe } from "@/service/wd_pubsub.js";
// api
import {
  wd_queryGptTalk,
  wd_cancelGptQueue,
  // wd_scoreAnswer,
  wd_getGptTalkMessageList,
  api_chat_is_task,
  api_generate_whole_semantic_ppt,
  api_upload_file
} from "../../api/apiAisa.js";
import { api_get_subscription_balance } from '@/views/subscriotion/services/subscriptionApi.js';
import { api_create_document_agent_user } from "@/pptjs/api/api_chat.js";
// import { getCustomProperties, getDocumentContentText } from "@/views/gpt/util/word_write_content";
import {
  getAllSlideText, insertTilteShape, optimizeSelectContent, translateSelectContent, integrateTextShape,
  getCurrentSelectState, addContentforSelectShape, insertTextShape, insertImgandReplace, getCurrentSlideJSONData, setSlideSelectedBySlideId,
} from "@/views/gpt/util/gpt_addin_utils";
import { insertImageByCompletionUrl } from "@/views/gpt/util/gpt_image";
import { getOrAddCopilotId, getAgentUserId, addAgentUserId } from "@/views/gpt/util/ppt_content_utils";
import { createWholePPT } from "@/views/gpt/task/process_ppt.js";
import { createOnepagePPT } from "@/views/gpt/task/process_onepage_general.js";
import { createOnePagePPTClassicBM } from "@/views/gpt/task/process_onepage_classic_canvas.js";
import { createOnePagePPTMarketAdoption } from "@/views/gpt/task/process_onepage_market_adoption.js";
import { createOnePagePPTMarketSize } from "@/views/gpt/task/process_onepage_market_size.js";
import { updateAllSlideDatafromJSONData, updateTemplateSlideDatafromJSONData, updateSlideContentWithJSONData, insertContentByTitle } from "@/views/gpt/util/gpt_addin_utils.js";

import { fetchEventSource } from "@microsoft/fetch-event-source";

//例如: import <组件名称> from  <组建路径>
import { PerfectScrollbar } from "vue2-perfect-scrollbar";
import { wdConfigData, userKeys, language_codes } from "@/service/wd_app_config.js";
import { i18n } from "@/plugins/i18n.js";
import { resetAllModulesState } from "@/store/modules/index.js"
import { ImageGenerateMode, ImageStyleMode } from "@/store/modules/enums.js";
import GenerateProcessing from "../../widgets/processing/card-generate-processing.vue";
import OnepageSlideDetailDialog from "../dialog/onepageSlideDetailDialog.vue";
import EnhancePromotMsgItem from "../dialog/enhancePromotMsgItem.vue";
import aiMenusZh from "@/store/modules/aiMenus-zh";
import aiMenusEn from "@/store/modules/aiMenus-en";
export default {
  //import 引入的组件需要注入到对象中才能使用
  components: {
    PerfectScrollbar,
    GenerateProcessing,
    OnepageSlideDetailDialog,
    EnhancePromotMsgItem
  },
  props: {
    uploadFileId: {
      type: String,
      required: false
    }
  },
  data() {
    //这里存放数据
    return {
      md: new MarkdownIt(),
      // Perfect scrollbar options
      perfectScrollbarOptions: {
        maxScrollbarLength: 60,
        wheelPropagation: false,
      },

      isLoadingData: false,
      chatLoadingText: i18n.t("chat.chat_document_init_loading"),
      messageList: [],
      pageCount: 10,

      // 向前翻页
      isLoadingPrevPage: false,
      scrollTopPrevPageHeight: 0,
      hasPrevPage: true,

      currentUser: null,
      gptTalk: null,
      currentGptQueue: null,
      // 打分
      scoringQueue: [],
      shownodata: false,
      isSending: false,

      // SSE
      sseMessageId: "",
      sseMessage: {},
      showBlinkCursor: false,
      showBlinkCursor1: false,
      showBlinkCursor2: false,
      blinkText:i18n.t('ppt_addin.process.text_blink_think'),
      blinkText1:i18n.t("home.generating_sending_remind_message_whole_template"),
      blinkText2:i18n.t('ppt_addin.process.text_blink_think'),
      eventSentenceIndex: 0,
      sentence: "",
      generatedString: "",
      timer: null,
      dialog: false,
      llm_error_message: i18n.t("home.llm_service_error"),
      rows: 0,
      isOutlineOptimizeLoading: false,
      outlineOptimize: {
        resourceContent: "",
        demandText: ""
      },
      currentOutlineIndex: 1,
      outlineContentArr: [],
      selectFile: null,
      selectFileId: "",
      imageHubUrl: "",
      translateDetailDialog: false,
      translateDetail:'',
      onePageSlideDataString:'',
      onPageSlideTextString:'',
      ImageStyle: [],
      ImageMode:[],

      // promptEnchance
      beforePromptEnchancedGenerateParams: null,
      propmptHasEnchanced: false,
      isEnchancePromptFailure: false,
    };
  },
  //计算机属性 类似与data概念
  computed: {
    ...get("gpt", ["actionTypes", "pptOptionMenus", "currentSelectContent", "currentSelectSlidePageIndex", "allSlidesJSONContent",  
    "selectedTaskType", "selectedTaskOptions", "autoActionType"]),
    ...sync("gpt", ["actionTypes", "pptOptionMenus", "currentSelectContent", "currentSelectSlidePageIndex", "allSlidesJSONContent",  
    "selectedTaskType", "selectedTaskOptions", "autoActionType"]),
  },
  //监控data中数据变化
  watch: {},
  methods: {
    fetchEventSourceclose() {
      new AbortController().abort;
    },
    // 直接使用import的方法
    // getCurrentUserAvatar,
    gettextlist(item) {
      if (item.Type == "Link") {
        this.$emit("gettextlist", item.Text);
      }
    },
    isSelf(message) {
      return isEqualGuidString(message.CreatorUserId, this.currentUser.Id);
    },
    isScored(message) {
      return message.Score != -1;
    },
    // scroll to bottom
    scrollToBottom() {
      this.$nextTick(() => {
        const scrollEl = this.$refs.refChatPS.$el;
        scrollEl.scrollTop = scrollEl.scrollHeight;
        this.scrollTopPrevPageHeight = scrollEl.scrollTop;
      });
    },
    onScroll() {
      // 不用带参数event
      const scrollEl = this.$refs.refChatPS.$el;
      if (scrollEl.scrollTop == 0 && this.isLoadingPrevPage == false) {
        // 加载前一页
        this.getGptTalkPrevPageMessages();
      }
    },
    queryGptTalk() {
      var params = {
        gptUserId: localStorage.getItem("AgentUserId"),
      };
      var that = this;
      this.chatLoadingText = i18n.t("chat.chat_log_init_loading")

      // if (localStorage.getItem(localStorage.getItem("AgentUserId")) != null) {
      //   this.gptTalk = JSON.parse(localStorage.getItem(localStorage.getItem("AgentUserId"))
      //   // 获取历史消息
      //   this.getGptTalkMessageList();
      //   this.scrollToBottom();
      //   return
      // }

      wd_queryGptTalk(params).then(
        (response) => {
          that.handleQueryGptTalkResponse(response);
        },
        (error) => {
          this.isLoadingData = false;
          console.log(error);
        }
      );
    },
    handleQueryGptTalkResponse(response) {
      if (response.data.Code == 0) {
        this.gptTalk = response.data.Talk;
        localStorage.setItem(localStorage.getItem("AgentUserId"), JSON.stringify(response.data.Talk))
        // 获取历史消息
        this.getGptTalkMessageList();
      } else if (response.data.Code == -1 && response.data.Description == "Need AT") {
        this.logout()
        this.$message.warning(i18n.t("home.login_status_error"));
      } else {
        this.$message.error(response.data.Description);
      }
    },
    logout() {
      localStorage.clear()
      resetAllModulesState()
      this.$router.replace("/login")
    },
    getGptTalkMessageList() {
      var params = {
        talkId: this.gptTalk.Id,
        start: 0,
        count: this.pageCount,
      };
      var that = this;

      //判断是否存在缓存的最新消息，如果存在，则先显示消息，再继续更新最新消息
      if (localStorage.getItem(this.gptTalk.Id) != null) {
        this.messageList = JSON.parse(localStorage.getItem(this.gptTalk.Id))
        this.scrollToBottom();
      }

      wd_getGptTalkMessageList(params).then(
        (res) => {
          that.handleGptTalkMessageListResponse(res);
        },
        (err) => {
          this.isLoadingData = false;
          console.log(err);
        }
      );
    },
    handleGptTalkMessageListResponse(res) {
      if (res.data.Code == 0) {
        var messages = this.msgListProcess(res.data.Messages);
        this.messageList = messages.reverse();
        // 添加欢迎语的消息
        let welcomeMessage = {
          Id: UUID(),
          Type: 7,
          CreatorUserId: "",
          showBtn: false,
          Link: "https://stcsm.sh.gov.cn/",
          Text: i18n.t("welcomeMessageCard.tittle"),
          ViewText:i18n.t("welcomeMessageCard.tittle"),
          action0_text: i18n.t("welcomeMessageCard.action_create_whole_template_slides"),
          action1_text: i18n.t("welcomeMessageCard.action_create_whole_slides"),
          action2_text: i18n.t("welcomeMessageCard.action_create_one_page_slide"),
          action3_text: i18n.t("welcomeMessageCard.action_create_slide_outline"),
          action4_text: i18n.t("welcomeMessageCard.action_create_ppt_from_file"),
          CreatedDate: d_localDateString(),
          Score: -1,
        }
        this.scrollToBottom();
        this.messageList.push(welcomeMessage)
        //缓存当前最新的一页消息
        localStorage.setItem(this.gptTalk.Id, JSON.stringify(this.messageList))

        // 判断是否还有前一页
        if (messages.length < this.pageCount) {
          this.hasPrevPage = false;
        }
      }
      // 判断当前订阅
      this.loadUserSubscriptionsStatus();

    },
    loadUserSubscriptionsStatus() {
      try {
        var that = this;
        api_get_subscription_balance().then(
          (response) => {
            if (response.data.Code === 0) {
              that.handleGetSubscriptionBalanceResponse(response);
            } else {
              console.error('Failed to get subscription balance:', response.data.Message);
            }
          },
          (error) => {
            console.error('Error fetching subscription balance:', error);
          }
        );
      } catch (error) {
        console.error('Failed to load subscriptions:', error);
      } finally {
        this.isLoadingData = false;
      }
    },
    handleGetSubscriptionBalanceResponse(response) {
      if (response.data.Code === 0) {
        if (response.data.Result.BalanceAmount <= 0 ) {
          this.addSubscriptionExpiredMessage();
          store.set("gpt/noSubscription", true);
        } else {
          store.set("gpt/noSubscription", false);
        }
      } else {
        console.error('Failed to get subscription balance:', response.data.Description);
      }
      this.isLoadingData = false;
    },
    addSubscriptionExpiredMessage() {
      // 添加订阅过期的消息
      let subscriptionExpiredMessage = {
        Id: UUID(),
        Type: 9,
        CreatorUserId: "",
        showBtn: false,
        Link: "https://stcsm.sh.gov.cn/",
        Text: i18n.t("welcomeMessageCard.tittle"),
        ViewText:i18n.t("welcomeMessageCard.tittle"),
        action_text: '查看订阅',
        CreatedDate: d_localDateString(),
        Score: -1,
      }
      this.messageList.push(subscriptionExpiredMessage)
      this.scrollToBottom();
    },
    parseViewText(msgViewText) {
      var enHancePormptList = []
      const requiredProperties = ['Title', 'Prompt'];
      try {
        enHancePormptList = JSON.parse(msgViewText)
      } catch (error) {
        console.log('parseMsgViewTextEnhancePromptfromJSONString: ', error)
      }
      const arr = enHancePormptList.filter(item =>
        requiredProperties.every(prop => Object.prototype.hasOwnProperty.call(item, prop))
      );
      
      enHancePormptList = arr
      return enHancePormptList.length > 0 ? enHancePormptList : []
    },
    enhancePromptConfirm(selectedItem) {
      this.propmptHasEnchanced = true;
      this.beforePromptEnchancedGenerateParams.IsPromptEnHance = false;
      // use enhanced prompt to generate ppt
      this.$emit("onSendEnchancePrompt", selectedItem.Prompt)
    },
    clickShowDetail(messageIndex) {
      if (messageIndex == this.messageList.length - 1) {
        this.scrollToBottom();
      } else {
        // TODO：滚动到本条消息的底部即可，不需要直接滚动列表最底部
      }
    },
    findStyleNameByStyleValue(targetValue) {
      for (const group of this.ImageStyle) {
        if (group && Array.isArray(group.styles)) {
          const foundItem = group.styles.find(style => 
            style && style.value.toLowerCase() === targetValue.toLowerCase()
          );
          
          if (foundItem) {
            return foundItem.text;
          }
        }
      }
      return this.ImageStyle[0].styles[0].text;
    },
    getImageDefaultStyleByMode() {
      let imageMode = localStorage.getItem(userKeys.key_user_settings_image_mode) || ImageGenerateMode.BUSINESS
      let imageStyles = this.ImageStyle.find(item => item.Mode === imageMode) || this.ImageStyle[0].styles
      return imageStyles[0].text;
    },
    msgListProcess(messagesList) {
      var messages = messagesList
      const safeParseJSON = (jsonString) => {
        if (!jsonString) return null;
        try {
          return jsonString ? JSON.parse(jsonString) : null;
        } catch (error) {
          console.error('JSON parse error:', error);
          return null;
        }
      };
      for (var i = 0; i < messages.length; i++) {
        var message = messages[i];
        message.isGenerating = false
        if (message.Type == "1") {
          message.ViewText = JSON.parse(message.AttachmentsJson);
        } else if (message.Type == "2") {
          message.ImageUrl = `${this.imageHubUrl}/${JSON.parse(message.AttachmentsJson).ImageId}_3_1024_1024.jpg`
          let GenerateImageStyle = JSON.parse(message.AttachmentsJson).GenerateImageStyle
          let GenerateImageMode = JSON.parse(message.AttachmentsJson).GenerateImageMode
          message.ViewText = message.Text
          if (GenerateImageMode) {
            message.Style = this.ImageMode.find(item => item.id === GenerateImageMode ).title + ': ' + (GenerateImageStyle == null || GenerateImageStyle == "" ? this.getImageDefaultStyleByMode() : this.findStyleNameByStyleValue(GenerateImageStyle))
          } else {
            message.Style = this.ImageMode[1].title + ': ' + (GenerateImageStyle == null || GenerateImageStyle == "" ? this.getImageDefaultStyleByMode() : this.findStyleNameByStyleValue(GenerateImageStyle))
          }
        } else if(message.Type === 8) {
          // JSONArray String
          message.ViewText = markdownSymbol(clearLineBreakSymbol(clearNotJsonBreakSymbol(message.Text)))
        } else {

          if (safeParseJSON(message.MetadataJson) && JSON.parse(message.MetadataJson).TaskType === 'task_ppt_translate_all' && !this.isSelf(message)) {
            message.Detail = clearLineBreakSymbol(clearNotJsonBreakSymbol(message.Text))
            message.ViewText = i18n.t('ppt_addin.process.text_msg_complete_translate')
          } else if (safeParseJSON(message.MetadataJson) && JSON.parse(message.MetadataJson).TaskType === 'task_one_page_general' && !this.isSelf(message)) {
            message.Detail = removeBeforeFirstBracket(lineBreakSymbol(clearNotJsonBreakSymbol(markdownSymbol(message.Text))))
            message.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
          } else if (safeParseJSON(message.MetadataJson) && JSON.parse(message.MetadataJson).TaskType === 'task_one_page_template' && !this.isSelf(message)) {
            message.Detail = removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(message.Text)))
            message.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
          } else if (safeParseJSON(message.MetadataJson) && JSON.parse(message.MetadataJson).TaskType === 'task_enrich_one_page_content' && !this.isSelf(message)) {
            message.Detail = removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(message.Text)))
            message.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
          } else if (this.isWholePPTMsg(message) && !this.isSelf(message)) {
            message.Detail = convertLineBreakSymbol(jsonBreakSymbol(markdownSymbol(clearNotJsonBreakSymbol(message.Text))))
            message.ViewText = i18n.t('ppt_addin.process.text_msg_complete_allSlides_generate')
          } else {
            // message.ViewText = convertLineBreakSymbol(message.Text)
            message.ViewText = message.Text
          }
        }
        // 统一过滤markdown等符号
        if(message.Type != 8) { // 8 is enhance prompt message
          // message.ViewText = jsonBreakSymbol(markdownSymbol(clearNotJsonBreakSymbol(message.ViewText)))
          // message.ViewText = message.ViewText
        }
        if (safeParseJSON(message.MetadataJson)) {
          if (JSON.parse(message.MetadataJson).TaskType == 'task_one_page_classic_canvas' || JSON.parse(message.MetadataJson).TaskType == 'task_one_page_market_size' || JSON.parse(message.MetadataJson).TaskType == 'task_one_page_market_adoption') {
            message.ViewText = jsonBreakSymbol(markdownSymbol(clearNotJsonBreakSymbol(message.Text)))
          }
        }
      }

      return messages
    },
    getGptTalkPrevPageMessages() {
      if (!this.hasPrevPage) {
        return;
      }
      var params = {
        talkId: this.gptTalk.Id,
        start: this.messageList.length,
        count: this.pageCount,
      };
      this.isLoadingPrevPage = true;
      var that = this;
      wd_getGptTalkMessageList(params).then(
        (response) => {
          that.isLoadingPrevPage = false;
          that.handleGptTalkPrevPageMessages(response);
        },
        (error) => {
          console.error(error);
          that.isLoadingPrevPage = false;
        }
      );
    },
    handleGptTalkPrevPageMessages(response) {
      if (response.data.Code == 0) {
        var messages = this.msgListProcess(response.data.Messages)
        this.messageList.unshift(...messages.reverse())
        // 控制翻页后，滚动条的位置，气泡还是显示在当前位置
        if (messages.length > 0) {
          this.$nextTick(() => {
            const scrollEl = this.$refs.refChatPS.$el;
            scrollEl.scrollTop =
              scrollEl.scrollHeight -
              this.scrollTopPrevPageHeight -
              scrollEl.offsetHeight;
            this.scrollTopPrevPageHeight =
              scrollEl.scrollHeight - scrollEl.offsetHeight;
          });
        }

        // 判断是否还有前一页
        if (messages.length < this.pageCount) {
          this.hasPrevPage = false;
        }
      } else {
        this.$message.error(response.data.Description);
      }
    },
    gotoWeb(url) {
      window.open(url, '_blank');
    },
    async sendSWTemplePromptMsg(texts) {
      // add local user message to message list
      var message = {
        Id: UUID(),
        CreatorUserId: this.currentUser.Id,
        Text: texts,
        CreatedDate: d_localDateString(),
        Score: -1,
        ViewText: texts
      };
      this.messageList.push(message);
      this.scrollToBottom();

      /**
       * Placeholder
       * 1.user waiting message, also to avoid the interface error
       * 2.AI will directly use this reserved message as the message body to display the content returned by AI to the user
       */
      this.sseMessageId = UUID();
      this.sseMessage = {
        Id: this.sseMessageId,
        CreatorUserId: "",
        Text: "",
        ViewText: '',
        CreatedDate: d_localDateString(),
        Score: -1,
        isGenerating: true,
        MetadataJson: ""
      };
      this.messageList.push(this.sseMessage);
      this.showBlinkCursor = true
      this.scrollToBottom();

      let generateParams = {
        Text: texts,
        TaskType: "",
        Content: "",
        ContentType: "",
        LcId: language_codes.ZH,
      }

      // set language according to user's local language
      if (wdConfigData.localLanguage == "zhHans") {
        generateParams.LcId = language_codes.ZH
      } else {
        generateParams.LcId = language_codes.EN
      }
      let that = this;

      // user clearfy select a task, no need to judge intent, just use the current selected content as reference
      generateParams.TaskType = this.selectedTaskType?.id || this.autoActionType?.id || "";
      generateParams.ContentType = this.selectedTaskOptions ? this.selectedTaskOptions.id : ""
      if (this.selectFileId || this.uploadFileId) {
        let fileIds = []
        fileIds.push(this.selectFileId ? this.selectFileId : this.uploadFileId)
        generateParams.FileIds = fileIds
      }
      // SJD: ShapeJsonData
      // 最快的方式是控制当前选中的slide，然后逐页完成单页的语义模板匹配和填充
      // 先忽略找不到等情况
      if (store.get("gpt/currentSelectedSemanticTemplateWhole")) {
        let previewWholeSemanticTemplates = JSON.parse(store.get("gpt/currentSelectedSemanticTemplateWhole"))
        let msgContent = '';
        let allFailure = true;
        try {
          for (let index = 0; index < previewWholeSemanticTemplates.length; index++) {
            const element = previewWholeSemanticTemplates[index];
            if (!element) continue;

            try {
              generateParams.TaskType = 'taskType_semantic_whole_template_ppt';
              generateParams.IsSemanticTemplateWhole = true;
              generateParams.TotlaPagesCount = previewWholeSemanticTemplates.length - 1
              generateParams.CurrentPageIndex = index
              await setSlideSelectedBySlideId(element.SlideId);

              const currentSelectedSlideJSONData = await new Promise((resolve, reject) => {
                getCurrentSlideJSONData((data) => {
                  if (data && data.length > 0) {
                    resolve(data);
                  } else {
                    reject(new Error(i18n.t("home.content_empty")));
                  }
                });
              });

              generateParams.SJD = JSON.stringify(currentSelectedSlideJSONData);
              that.blinkText = i18n.t("home.generating_sending_remind_message");
              that.showBlinkCursor1 = true
              that.showBlinkCursor2 = true
              that.blinkText1 = i18n.t("home.generating_sending_remind_message_whole_template");
              that.blinkText2 = i18n.t("home.generating_sending_remind_message_whole_template_process").replace(/\{0\}/g, previewWholeSemanticTemplates.length + "").replace(/\{1\}/g, index + 1 + "");
              
              that.scrollToBottom();
              
              const response = await new Promise((resolve, reject) => {
                api_generate_whole_semantic_ppt(generateParams, this.gptTalk.Id)
                  .then(resolve)
                  .catch(reject);
              });

              if (response.data.Code !== 0) {
                throw new Error(response.data.Message || that.llm_error_message);
              }

              if (response.data.Message.Text.includes(that.llm_error_message)) {
                that.$message.warning(i18n.t("ppt_add_in_main.server_general_error_message"));
                continue;
              }

              allFailure = false;
              const msgCurrentPageContent = response.data.Message.Text;
              msgContent += msgCurrentPageContent;

              const cleanedContent = removeBeforeFirstBracket(
                clearLineBreakSymbol(
                  clearNotJsonBreakSymbol(msgCurrentPageContent)
                )
              );
              await updateTemplateSlideDatafromJSONData(cleanedContent, element.SlideId)
            } catch (error) {
              console.log(`something worng when process no. ${index + 1} :`, error);
              that.$message.warning(error.message || 'something wrong when process slide content' );
              // you can continue to process the next or break
              continue;
              // or throw error, completely stop
            }
          }
        } catch (outerError) {
          console.error('outer error catch :', outerError);
        }
        
        // error
        if (allFailure) {
          that.$message.error(i18n.t("home.server_error_message"));
          that.resetChatStatus();
          // process the delete cursor and add empty message
          that.messageList.splice(that.messageList.length - 1, 1)
        }

        /**
         * update sseMessage to MessageLogList
         */
        that.sseMessage.MetadataJson = "{\"TaskType\":\"taskType_semantic_whole_template_ppt\"}"
        that.sseMessage.Detail = removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)))
        that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
        that.sseMessage.Text = msgContent
        /**
         * reset all status
         * inputBox, loading, waiting text ...
         */
        that.showBlinkCursor = false
        that.showBlinkCursor1 = false
        that.showBlinkCursor2 = false
        that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
        that.sseMessage.isGenerating = false

        // add current latest message to local cache
        localStorage.setItem(that.gptTalk.Id, JSON.stringify(that.messageList))

        that.resetChatStatus();
        that.scrollToBottom();
      }
    },
    judgeInputIsTask(texts) {
      if (!this.gptTalk){
        this.resetChatStatus();
        this.$message.warning(i18n.t("ppt_add_in_main.paramter_error"))
        return
      }
      // add local user message to message list
      var message = {
        Id: UUID(),
        CreatorUserId: this.currentUser.Id,
        Text: texts,
        CreatedDate: d_localDateString(),
        Score: -1,
        ViewText:texts
      };
      this.messageList.push(message);
      this.scrollToBottom();

      /**
       * Placeholder
       * 1.user waiting message, also to avoid the interface error
       * 2.AI will directly use this reserved message as the message body to display the content returned by AI to the user
       */
      this.sseMessageId = UUID();
      this.sseMessage = {
        Id: this.sseMessageId,
        CreatorUserId: "",
        Text: "",
        ViewText:'',
        CreatedDate: d_localDateString(),
        Score: -1,
        isGenerating: true,
        MetadataJson: ""
      };
      this.messageList.push(this.sseMessage);
      this.blinkText = i18n.t('ppt_addin.process.text_blink_think')
      this.showBlinkCursor = true
      this.scrollToBottom();

      
      let generateParams = {
        Text: texts,
        TaskType: "",
        Content: "",
        ContentType: "",
        LcId: language_codes.ZH,
        IsPromptEnHance: false,
      }
      
      // set language according to user's local language
      if (wdConfigData.localLanguage == "zhHans") {
        generateParams.LcId = language_codes.ZH
      } else {
        generateParams.LcId = language_codes.EN
      }

      let that = this
      if (this.selectedTaskType == null && this.autoActionType == null) {
        if (that.propmptHasEnchanced && that.beforePromptEnchancedGenerateParams) {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_prompt_recognition')
          that.beforePromptEnchancedGenerateParams.Text = texts 
          // use enhanced prompt to generate ppt
          that.chatqaAdd(that.beforePromptEnchancedGenerateParams)
        } else {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_intent_recognition')
          // get intent from user's input text
          api_chat_is_task(texts, this.gptTalk.Id).then(
            (response) => {
              if (response.data.Code == 0) {
                if(response.data.Message.Text.includes(that.llm_error_message)){
                  that.showBlinkCursor = false
                  that.messageList.splice(that.messageList.length - 1, 1)
                  that.resetChatStatus()
                  that.$message.warning(i18n.t("ppt_add_in_main.server_general_error_message"))
                  return
                }
                that.blinkText = i18n.t('ppt_addin.process.text_blink_intent_recognition_success')
                const intentObj = JSON.parse(response.data.Message.Text)
                switch (intentObj.intent) {
                  case "Whole":
                    generateParams.TaskType = 'task_all_normal'
                    generateParams.ContentType = that.pptOptionMenus[0].id
                    generateParams.IsPromptEnHance = !that.propmptHasEnchanced
                    that.isEnchancePromptFailure = false
                    break;
                  case "Onepage":
                    generateParams.TaskType = 'task_one_page_general'
                    generateParams.IsPromptEnHance = !that.propmptHasEnchanced
                    that.isEnchancePromptFailure = false
                    break;
                  case "Adjust Onepage": // unused
                    generateParams.TaskType = "task_expand_silde_content"
                    generateParams.Content = that.currentSelectContent
                    break;
                  case "General Chat":
                    break;
                  default:
                    // no intent, create one page ppt
                    generateParams.TaskType = 'task_expand_silde_content'
                    break;
                }
                store.set('gpt/template_current_type', intentObj.subject || 'B/P')
              } else {
                that.showBlinkCursor = false
                that.messageList.splice(that.messageList.length - 1, 1)
                that.resetChatStatus()
                that.$message.warning(i18n.t("home.content_empty"))
                return
              }

              if (generateParams.TaskType == "") {
                that.needUpdateContent(generateParams)
              } else {
                that.chatqaAdd(generateParams)
              }
            },
            (error) => {
              console.log(error)
              that.needUpdateContent(generateParams)
            }
          );
        }
      } else {
        // user clearfy select a task, no need to judge intent, just use the current selected content as reference
        generateParams.TaskType = this.selectedTaskType?.id || this.autoActionType?.id || "";
        generateParams.ContentType = this.selectedTaskOptions ? this.selectedTaskOptions.id : ""

        // if user select file, use the file to generate ppt
        if (this.selectFileId || this.uploadFileId) {
          let fileIds = []
          fileIds.push(this.selectFileId ? this.selectFileId : this.uploadFileId)
          generateParams.FileIds = fileIds
        }

        if (generateParams.TaskType == 'taskType_outline_optimize' || generateParams.TaskType == 'taskType_outline_ppt') {
          generateParams.Content = this.outlineOptimize.resourceContent
        } else {
          generateParams.Content = this.currentSelectContent
        }

        // no need to update content and just use the selected content
        if (this.autoActionType) {
          generateParams.TaskType = generateParams.TaskType == 'task_generate_image_replace' ? 'task_generate_image' : generateParams.TaskType

          // if task is image generate, need add image style params
          if (generateParams.TaskType == 'task_generate_image') {
            generateParams.GenerateImageMode = localStorage.getItem(userKeys.key_user_settings_image_mode) || ImageGenerateMode.BUSINESS
            generateParams.GenerateImageStyleMode = localStorage.getItem(userKeys.key_user_settings_image_style_mode) || ImageStyleMode.AI
            generateParams.GenerateImageStyle = this.ImageStyle.find(item => item.Mode === generateParams.GenerateImageMode).styles[localStorage.getItem(userKeys.key_user_settings_image_style_index) || 0].value
          }

          if (generateParams.TaskType === 'task_enrich_one_page_content') {
            // SJD: ShapeJsonData
            generateParams.SJD = this.currentSelectContent
            this.chatqaAdd(generateParams)
          } else if (generateParams.TaskType === 'taskType_one_page_content_from_title') { // based on title
            generateParams.Content = this.currentSelectContent
            generateParams.Text = i18n.t("chat.text_prompt_generate_base_title_pageindex") + this.currentSelectSlidePageIndex + ', ' + i18n.t("chat.text_prompt_generate_base_title_new_slide_title") + this.currentSelectContent;
            getAllSlideText((content) => {
              generateParams.Content = content
              this.chatqaAdd(generateParams)
            }, () => {
              this.$message.warning(i18n.t("chat.chat_log_update_faile"))
              this.chatqaAdd(generateParams)
            })
          } else {
            this.chatqaAdd(generateParams)
          }
        } else {
          // taskType is selectedTaskType, no need to update content
          if (generateParams.TaskType == 'taskType_outline' || generateParams.TaskType == 'taskType_outline_optimize' || generateParams.TaskType == 'taskType_outline_ppt') {
            this.chatqaAdd(generateParams)
          } else if (generateParams.TaskType == 'task_ppt_translate_all_en' || generateParams.TaskType == 'task_ppt_translate_all_zh') {
            generateParams.translateTargetLcId = language_codes.EN
            switch (generateParams.TaskType) {
              case 'task_ppt_translate_all_en':
                generateParams.translateTargetLcId = language_codes.EN
                break;
              case 'task_ppt_translate_all_zh':
                generateParams.translateTargetLcId = language_codes.ZH
                break;
              default:
                break;
            }
            /** reset taskType task_ppt_translate_all，beacause server accept that type */
            generateParams.TaskType = 'task_ppt_translate_all'
            let allTextSlides = []
            const allSideJSONData = JSON.parse(this.allSlidesJSONContent)
            /** Only first 20 pages */
            for (let index = 0; index < Math.min(allSideJSONData.length, wdConfigData.maxTranslatePages); index++) {
              let element = allSideJSONData[index]
              element.PC = element.PC.filter(item => item.SC.length > 0)
              allTextSlides.push(element)
            }
            generateParams.Content = JSON.stringify(allTextSlides)
            this.chatqaAdd(generateParams)
          } else if (generateParams.TaskType === 'task_one_page_general' && store.get('gpt/currentSelectedTemplateName')) {
            // SJD: ShapeJsonData
            let sjd = localStorage.getItem(userKeys.key_user_settings_preview_template_shape_data)
            generateParams.TaskType = 'task_one_page_template'
            generateParams.SJD = sjd || JSON.stringify([{ "ST": "Placeholder", "SN": "Title 2", "SC": "标题" }, { "ST": "Placeholder", "SN": "Text Placeholder 4", "SC": "内容" }])
            generateParams.Content = this.onPageSlideTextString
            this.chatqaAdd(generateParams)
          } else {
            this.needUpdateContent(generateParams)
          }
        }
      }
    },
    needUpdateContent(generateParams) {
      this.blinkText = i18n.t('ppt_addin.process.text_blink_update_slides_content')
      // general chat no need content
      getOrAddCopilotId((copilotID) => {
        getAllSlideText((content) => {
          var params = {
            FileName: copilotID,
            Content: content
          };
          api_create_document_agent_user(params).then(
            (response) => {
              if (response.data == null || response.data.Code != 0) {
                //todo need a dialog to show error
                this.$message.warning(i18n.t("chat.chat_log_update_faile"))
              }
              this.chatqaAdd(generateParams)
            },
            () => {
              this.$message.warning(i18n.t("chat.chat_log_update_faile"))
              this.chatqaAdd(generateParams)
            }
          );
        }, () => {
          this.$message.warning(i18n.t("chat.chat_log_update_faile"))
          this.chatqaAdd(generateParams)
        });
      }, () => {
        this.$message.warning(i18n.t("chat.chat_log_update_faile"))
        this.chatqaAdd(generateParams)
      })
    },
    /* eslint-disable */
    chatqaAdd(generateParams) {
      let that = this;

      let slideMessageContent = ""
      let shapeMessageContent = ""
      let msgContent = ''

      that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
      if (generateParams.TaskType == 'task_generate_image') {
        let timeSecond1 = Math.floor(Math.random() * 51) * 100 + 10000
        let timeSecond2 = Math.floor(Math.random() * 51) * 100 + 15000
        let timeSecond3 = Math.floor(Math.random() * 51) * 100 + 15000
        setTimeout(function () {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_image_generate_key_elements')
        }, timeSecond1);
        
        setTimeout(function () {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_image_generate_prompt')
        }, timeSecond1 + timeSecond2);
        
        setTimeout(function () {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_image_generate')
        }, timeSecond1 + timeSecond2 + timeSecond3);
      }
      if (that.propmptHasEnchanced && that.beforePromptEnchancedGenerateParams) {
        that.blinkText = i18n.t('ppt_addin.process.text_blink_prompt_recognition')
        setTimeout(function () {
          that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
        }, 3000);
      }

      var accessToken = localStorage.getItem(
        userKeys.key_corporationAccessToken
      );

      // 如果taskType需要content，而此时没有选中任何有效内容，则需要直接给提示
      if (that.actionTypes.find(item => item.id === generateParams.TaskType) != null && generateParams.Content == "") {
        that.showBlinkCursor = false
        that.messageList.splice(that.messageList.length - 1, 1)
        that.resetChatStatus()
        that.$message.warning(i18n.t("home.content_empty"))
        return
      }

      // 如果是生成大纲或者优化大纲，需要给本地消息增加MetadataJson
      if (generateParams.TaskType == 'taskType_outline' || generateParams.TaskType == 'taskType_outline_optimize') {
        that.sseMessage.MetadataJson = JSON.stringify({ TaskType: generateParams.TaskType })
      }

      //建立长连接的接口
      var url = `${wdConfigData.baseURLApi}/Talks/${this.gptTalk.Id}/Messages/CreateAsStream`
      fetchEventSource(url, {
        method: "POST",
        body: JSON.stringify(generateParams),
        headers: {
          AccessToken: accessToken,
          "Content-Type": "application/json",
          Connection: "keep-alive",
        },
        async onopen(response) {
          console.log("onopen");
          if (response.ok && response.headers.get("content-type") === "text/event-stream") {
            // everything's good
            console.log("everything's good");
          } else if (response.status == 200) {
            console.log("connect success: 200");

            if (generateParams.TaskType == 'taskType_outline_optimize') {
              that.outlineOptimize.resourceContent = ""
              that.outlineContentArr.push(that.outlineOptimize.resourceContent)
              that.currentOutlineIndex = that.outlineContentArr.length
            }
          } else {
            that.$message.error(i18n.t("home.server_error_message"));
            that.resetChatStatus();
            //处理一下删除光标和添加的空消息
            that.messageList.splice(that.messageList.length - 1, 1)
          }
        },
        async onmessage(event) {
          if (event.data != "[DONE]" && event.data.indexOf("Error:") === -1) {
            slideMessageContent += lineBreakSymbol(event.data)
            shapeMessageContent += lineBreakSymbol(event.data)
            msgContent += event.data
            
            if (slideMessageContent.includes(that.llm_error_message) || shapeMessageContent.includes(that.llm_error_message)) {
              // 关闭连接，更新界面状态
              that.fetchEventSourceclose();
              that.sseMessage.isGenerating = false
              that.resetChatStatus();
              that.scrollToBottom();
              return;
            }
          }
          // 表示整体结束
          if (event.data === "[DONE]") {
            console.log("[DONE]");

            if (generateParams.TaskType == 'taskType_outline_optimize') {
              setTimeout(function () {
                that.outlineContentArr[that.outlineContentArr.length - 1] = that.outlineOptimize.resourceContent
              }, 100)
            }

            //把当前最新的消息添加到缓存数据中
            localStorage.setItem(that.gptTalk.Id, JSON.stringify(that.messageList))

            if (slideMessageContent.includes(that.llm_error_message) || shapeMessageContent.includes(that.llm_error_message)) {
              // 关闭连接，更新界面状态
              that.fetchEventSourceclose();
              that.sseMessage.isGenerating = false
              that.resetChatStatus();
              //处理一下删除光标和添加的空消息
              that.messageList.splice(that.messageList.length - 1, 1)
              that.showBlinkCursor = false
              that.$message.warning(i18n.t("home.server_error_but_success_message"))
              return;
            }
            switch (generateParams.TaskType) {
              case "task_bp_normal":
              case "task_bp_tan_methodology":
              case "task_all_normal":
              case "taskType_outline_ppt":
              case "taskType_ppt_from_file":
                if (generateParams.IsPromptEnHance && !that.propmptHasEnchanced) {
                  that.beforePromptEnchancedGenerateParams = generateParams
                  const msgContentRegString = markdownSymbol(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)));
                  if (that.parseViewText(msgContentRegString).length > 0) {
                    that.sseMessage.Type = 8
                    that.sseMessage.Text = clearNotJsonBreakSymbol(msgContent)
                    that.sseMessage.ViewText = msgContentRegString
                    that.sseMessage.MetadataJson = "{\"TaskType\":\"task_all_normal\", \"IsPromptEnHance\":\"true\"}"
                    // 还原loadingText到初始化状态
                    that.showBlinkCursor = false
                    that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                  } else {
                    that.isEnchancePromptFailure = true
                    // 2秒后还原，避免用户无法看到提示，第一次返回不需要清空loading/thinking，第二次返回再清空重置状态
                    setTimeout(function () {
                      that.isEnchancePromptFailure = false
                      that.scrollToBottom();
                    }, 2000);
                    
                    // 还原loadingText到生成开始的状态
                    that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                    // 使用原本的sseMessage预留位Object
                    that.showBlinkCursor = true

                    // 去生成PPT
                    that.propmptHasEnchanced = true;
                    that.beforePromptEnchancedGenerateParams.IsPromptEnHance = false;
                    that.chatqaAdd(that.beforePromptEnchancedGenerateParams)
                  }
                } else {
                  createWholePPT(slideMessageContent)
                  that.sseMessage.MetadataJson = "{\"TaskType\":\"task_all_normal\"}"
                  that.sseMessage.Detail = removeBeforeFirstBracket(convertLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)))
                  that.sseMessage.Text = msgContent
                  that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_allSlides_generate')
                  that.propmptHasEnchanced = false
                  // 还原loadingText到初始化状态
                  that.showBlinkCursor = false
                  that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                }
                break;
              case "task_one_page_general":
                if (generateParams.IsPromptEnHance && !that.propmptHasEnchanced) {
                  that.beforePromptEnchancedGenerateParams = generateParams
                  const msgContentRegString = markdownSymbol(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)));
                  
                  if (that.parseViewText(msgContentRegString).length > 0) {
                    that.sseMessage.Type = 8
                    that.sseMessage.Text = clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent))
                    that.sseMessage.ViewText = msgContentRegString
                    that.sseMessage.MetadataJson = "{\"TaskType\":\"task_one_page_general\", \"IsPromptEnHance\":\"true\"}"
                    // 还原loadingText到初始化状态
                    that.showBlinkCursor = false
                    that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                  } else {
                    that.isEnchancePromptFailure = true
                    // 2秒后还原，避免用户无法看到提示，第一次返回不需要清空loading/thinking，第二次返回再清空重置状态
                    setTimeout(function () {
                      that.isEnchancePromptFailure = false
                      that.scrollToBottom();
                    }, 2000);
                    
                    // 还原loadingText到生成开始的状态
                    that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                    // 使用原本的sseMessage预留位Object
                    that.showBlinkCursor = true
                    
                    // 去生成PPT
                    that.propmptHasEnchanced = true;
                    that.beforePromptEnchancedGenerateParams.IsPromptEnHance = false;
                    that.chatqaAdd(that.beforePromptEnchancedGenerateParams)
                    that.scrollToBottom();
                  }
                } else {
                  createOnepagePPT(slideMessageContent)
                  that.sseMessage.MetadataJson = "{\"TaskType\":\"task_one_page_general\"}"
                  that.sseMessage.Detail = removeBeforeFirstBracket(lineBreakSymbol(clearNotJsonBreakSymbol(markdownSymbol(msgContent))))
                  that.sseMessage.Text = msgContent
                  that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
                  that.propmptHasEnchanced = false
                  that.showBlinkCursor = false
                  that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                }
                break;
              case "task_one_page_classic_canvas":
                createOnePagePPTClassicBM(clearNotJsonBreakSymbol(slideMessageContent))
                break;
              case "task_one_page_market_size":
                createOnePagePPTMarketSize(clearNotJsonBreakSymbol(slideMessageContent))
                break;
              case "task_one_page_market_adoption":
                createOnePagePPTMarketAdoption(clearNotJsonBreakSymbol(slideMessageContent))
                break;
              case "task_expand_silde_content":
                getCurrentSelectState((currentState) => {
                  let slideState = currentState.selectSlide.state
                  let shapeState = currentState.selectShape.state
                  if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
                    switch (shapeState) {
                      case i18n.t("ppt_select_state.select_no_shape"):
                      case i18n.t("ppt_select_state.select_mluti_shapes"):
                        // to 根据当前内容插入一个新的文本框
                        insertTextShape(markdownSymbol(shapeMessageContent))
                        break;
                      case i18n.t("ppt_select_state.select_one_shape"):
                        // to 在当前shape内容后插入内容
                        addContentforSelectShape(markdownSymbol(shapeMessageContent))
                        break;
                      default:
                        break;
                    }
                  } else {
                    // todo 选中多个slides的时候，直接根据当前内容插入一页新的slide
                  }
                })
                break;
              // case "task_extract_slide_content":

              //   break;
              case "task_generate_image":
              case "task_generate_image_replace":
                if (that.autoActionType.id == 'task_generate_image_replace') {
                  insertImgandReplace()
                }
                break;
              case "taskType_create_title":
                insertTilteShape(markdownSymbol(shapeMessageContent))
                break;
              case "taskType_integrate_text":
                integrateTextShape(markdownSymbol(shapeMessageContent))
                break;
              case "task_rewrite_text":
                optimizeSelectContent(markdownSymbol(shapeMessageContent))
                break;
              case "taskType_ppt_translation":
                translateSelectContent(markdownSymbol(shapeMessageContent))
                break;
              case "taskType_outline":
                that.showOutlineDialog(markdownSymbol(shapeMessageContent))
                break;
              case "task_ppt_translate_all":
                updateAllSlideDatafromJSONData(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)))
                that.sseMessage.MetadataJson = "{\"TaskType\":\"task_ppt_translate_all\"}"
                that.sseMessage.Detail = clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent))
                that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_translate')
                that.sseMessage.Text = msgContent
                that.showBlinkCursor = false
                that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                break;
              case "task_one_page_template":
                updateTemplateSlideDatafromJSONData(removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent))), store.get('gpt/currentPreviewSlideId'))
                that.sseMessage.MetadataJson = "{\"TaskType\":\"task_one_page_template\"}"
                that.sseMessage.Detail = removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)))
                that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
                that.sseMessage.Text = msgContent
                that.showBlinkCursor = false
                that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                break;
              case "task_enrich_one_page_content":
                updateSlideContentWithJSONData(removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent))))
                that.sseMessage.MetadataJson = "{\"TaskType\":\"task_enrich_one_page_content\"}"
                that.sseMessage.Detail = removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msgContent)))
                that.sseMessage.ViewText = i18n.t('ppt_addin.process.text_msg_complete_onepageslide_generate')
                that.sseMessage.Text = msgContent
                that.showBlinkCursor = false
                that.blinkText = i18n.t('ppt_addin.process.text_blink_think')
                break;
              case "taskType_one_page_content_from_title":
                insertContentByTitle(shapeMessageContent)
                break;
              default:
                break;
            }

            // 关闭连接，更新界面状态
            that.fetchEventSourceclose();
            return;
          }

          //处理status = 200但出现逻辑性错误的情况
          if (event.data.indexOf("Error:") > -1) {
            console.log("Error:");
            let errorMessage = event.data.replace("Error:", "")
            if (errorMessage.includes('未将对象引用设置到对象的实例')) {
              errorMessage = i18n.t("home.server_error_but_success_message")
            }
            // need to judge if the error is from prompt enhance, if so, do not close the connection
            if (!generateParams.IsPromptEnHance) {
              that.$message.warning(errorMessage)
              that.fetchEventSourceclose()
              // 界面状态更新
              that.resetChatStatus()
              //处理一下删除光标和添加的空消息
              that.messageList.splice(that.messageList.length - 1, 1)
              that.showBlinkCursor = false
              return;
            } else {
              console.log("Error from prompt enhance, do not close the connection")
            }
          }

          //处理status = 200但出现逻辑性错误的情况
          if (event.data.indexOf("Code:") > -1) {
            let Code = event.data.replace("Code:", "")
            let description = Code
            switch (Code) {
              case "-1":
                description = i18n.t("home.license_error_description_901")
                break;
              case "-901":
                description = i18n.t("home.license_error_description_901")
                break;
              case "-902":
                description = i18n.t("home.license_error_description_901")
                break;
              case "-903":
                description = i18n.t("home.license_error_description_901")
                break;
              case "-904":
                description = i18n.t("home.license_error_description_901")
                break;
              default:
                description = Code
                break;
            }
            that.$message.warning(description)
            that.fetchEventSourceclose()
            // 界面状态更新
            that.resetChatStatus()
            //处理一下删除光标和添加的空消息
            that.messageList.splice(that.messageList.length - 1, 1)
            that.showBlinkCursor = false

            that.addSubscriptionExpiredMessage();
            store.set("gpt/noSubscription", true);
            return;
          }

          if (isEmptyGuidStr(that.sseMessageId)) {
            that.sseMessageId = UUID()
            that.sseMessage = {
              Id: that.sseMessageId,
              CreatorUserId: "",
              Text: event.data,
              CreatedDate: d_localDateString(),
              Score: -1,
              MetadataJson: "",
              ViewText:convertLineBreakSymbol(event.data)
            };
            that.messageList.push(that.sseMessage);
            that.scrollToBottom();
          } else {
            // 图片消息
            if (event.data.includes("CustomerMessage")) {
              // if (that.imgGenerateProgress < 100) {
              //   that.imgGenerateProgress = 100
              // }
              var imageObj = JSON.parse(event.data)
              that.sseMessage.Type = imageObj.CustomerMessage.Type
              that.sseMessage.ImageUrl = `${that.imageHubUrl}/${JSON.parse(imageObj.CustomerMessage.AttachmentsJson).ImageId}_3_1024_1024.jpg`
              let GenerateImageStyle = JSON.parse(imageObj.CustomerMessage.AttachmentsJson).GenerateImageStyle
              let GenerateImageMode = JSON.parse(imageObj.CustomerMessage.AttachmentsJson).GenerateImageMode
              that.sseMessage.Style = that.ImageMode.find(item => item.id === GenerateImageMode ).title + ': ' + (GenerateImageStyle == null || GenerateImageStyle == "" ? that.getImageDefaultStyleByMode() : that.findStyleNameByStyleValue(GenerateImageStyle))
              setTimeout(function () {
                that.scrollToBottom();
              }, 200);
              that.showBlinkCursor = false;
              that.showImgProgress = false

              if (that.sseMessage.Type == 2) {
                let options = {
                  coercionType: Office.CoercionType.Image,
                  imageLeft: 480,
                  imageTop: 70,
                  imageWidth: 400,
                  imageHeight: 400,
                };
                insertImageByCompletionUrl(that.sseMessage.ImageUrl, options)
              }
              for (let index = 0; index < that.ImageStyle.length; index++) {
                that.ImageStyle[index].selected = GenerateImageStyle == that.ImageStyle[index].value
              }
            } else {
              setTimeout(function () {
                const wholePPTTypes = ['task_bp_normal', 'task_bp_tan_methodology', 'task_all_normal', 'taskType_outline_ppt', 'taskType_ppt_from_file']
                if(generateParams.TaskType === 'task_ppt_translate_all') {
                  that.blinkText = i18n.t('ppt_addin.process.text_blink_translate')
                } 
                else if(wholePPTTypes.indexOf(generateParams.TaskType) != -1) {
                  that.blinkText = (generateParams.TaskType === 'task_all_normal' && generateParams.IsPromptEnHance) ? i18n.t('ppt_addin.process.text_blink_enchance_prompt') : i18n.t('ppt_addin.process.text_blink_generate_content')
                }
                else if (generateParams.TaskType === 'task_one_page_general') {
                  that.blinkText = generateParams.IsPromptEnHance ? i18n.t('ppt_addin.process.text_blink_enchance_prompt') : i18n.t('ppt_addin.process.text_blink_generate_content')
                }
                 else if (generateParams.TaskType === 'task_one_page_template' || generateParams.TaskType === 'task_enrich_one_page_content'){
                  that.blinkText = i18n.t('ppt_addin.process.text_blink_generate_content')
                } else {
                  that.blinkText = i18n.t('ppt_addin.process.text_blink_generate_content')
                  if (generateParams.TaskType == 'task_one_page_classic_canvas' || generateParams.TaskType == 'task_one_page_market_size' || generateParams.TaskType == 'task_one_page_market_adoption') {
                    that.sseMessage.ViewText += jsonBreakSymbol(markdownSymbol(clearNotJsonBreakSymbol(event.data)))
                  } else {
                    that.sseMessage.ViewText += event.data
                  }
                  that.sseMessage.Text += event.data
                  that.showBlinkCursor = false
                  if (generateParams.TaskType == 'taskType_outline_optimize') {
                    that.outlineOptimize.resourceContent += lineBreakSymbol(jsonBreakSymbol(markdownSymbol(clearNotJsonBreakSymbol(event.data))))
                    that.isOutlineOptimizeLoading = false
                  }
                  that.scrollToBottom();
                }
              }, 100)
            }
          }
        },
        async onerror() {
          console.error("onerror");
          that.$message.error(i18n.t("home.server_error_message"));
          that.resetChatStatus();
          //处理一下删除光标和添加的空消息
          that.messageList.splice(that.messageList.length - 1, 1)
        },
        async onclose() {
          // if the server closes the connection unexpectedly, retry:
          console.log("connection close");
          if (!that.isEnchancePromptFailure) {
            that.sseMessage.isGenerating = false
            that.resetChatStatus();
            that.scrollToBottom();
          }
        },
      });
    },
    isGeneralMsg(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['taskType_outline', 'taskType_outline_optimize', 'task_ppt_translate_all', 'task_one_page_general', 'task_one_page_template', 'task_bp_normal', 'task_bp_tan_methodology', 'task_all_normal', 'taskType_outline_ppt', 'taskType_ppt_from_file', 'task_enrich_one_page_content']
          return !specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return true
        }
      } else {
        return true
      }
    },
    isWholePPTMsg(message){
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['task_bp_normal', 'task_bp_tan_methodology', 'task_all_normal', 'taskType_outline_ppt', 'taskType_ppt_from_file']
          return specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    },
    isTranslateAllMsg(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['task_ppt_translate_all']
          return specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    },
    isImgMsg(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['taskType_outline', 'taskType_outline_optimize', 'task_ppt_translate_all', 'task_one_page_general', 'task_one_page_template', 'task_enrich_one_page_content']
          return !specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return true
        }
      } else {
        return true
      }
    },
    isOnePageSlide(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['task_one_page_general', 'task_one_page_template', 'task_enrich_one_page_content']
          return specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return false
        }
      } else {
        return false
      }

    },
    isOnePageTemplateSlide(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['task_one_page_template']
          return specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return false
        }
      } else {
        return false
      }

    },
    isOutlineMessage(message) {
      if (message.MetadataJson) {
        try {
          let metaDatJson = JSON.parse(message.MetadataJson)
          const specialMsgTypes = ['taskType_outline', 'taskType_outline_optimize']
          return specialMsgTypes.includes(metaDatJson.TaskType) 
        } catch (error) {
          return false
        }
      } else {
        return false
      }
    },
    showWholeDetail(message){
      this.onePageSlideDataString = convertLineBreakSymbolReverse(message.Detail)
      this.$refs.refOnepageSlideDetailDialog.showDialog()
    },
    showOnePageSlideDialog(message) {
      let detailString = ''
      let detailJSONData = null
      try {
        detailJSONData = JSON.parse(message.Detail)
      } catch (error) {
        detailJSONData = [
          {
            SC: jsonBreakSymbol(message.Detail).replace(/GeometricShape|Rectangle|Placeholder|TextBox|ST|SN|SC/g, '')
          }
        ]
      }
      for (let j = 0; j < detailJSONData.length; j++) {
        const shapeContent = detailJSONData[j];
        if (j > 0) detailString += '\n'
        detailString += shapeContent.SC.replace(/\*\*\*###/g, '\n')
      }
      this.onePageSlideDataString = detailString

      this.$refs.refOnepageSlideDetailDialog.showDialog()
    },
    showTranslateDetail(message) {
      this.translateDetailDialog = true
      let detailString = ''
      
      let detailJSONData = JSON.parse(message.Detail)
      for (let index = 0; index < detailJSONData.length; index++) {
        const element = detailJSONData[index]
        if (index > 0) detailString += '\n'
        detailString += '第' + (element.PI+1) + '页：' + '\n'
        for (let j = 0; j < element.PC.length; j++) {
          const shapeContent = element.PC[j];
          detailString += shapeContent.TSC
        }
      }
      
      this.translateDetail = detailString
    },
    closeTranslateDialog() {
      this.translateDetailDialog = false
      this.translateDetail = ''
      this.scrollToBottom()
    },
    showOutlineDialog(messageContent) {
      this.outlineOptimize.resourceContent = convertLineBreakSymbolReverse(lineBreakSymbol(messageContent))
      this.dialog = true
      this.currentOutlineIndex = 1
      this.outlineContentArr.push(convertLineBreakSymbolReverse(lineBreakSymbol(messageContent)))
    },
    hideOutlineDialog() {
      this.outlineContentArr = []
      this.dialog = false
    },
    resetChatStatus() {
      this.selectFile = ""
      publish(aisaPubIds.pubId_Local_Aisa_AskGpt_Success, {});
      localStorage.setItem(userKeys.key_user_generate_slide_is_change_one_page_template, JSON.stringify(false))
    },
    cancelGptQueue() {
      if (this.currentGptQueue == null) {
        return;
      }
      var params = {
        talkId: this.gptTalk.Id,
        queueId: this.currentGptQueue.Id,
      };
      var that = this;
      wd_cancelGptQueue(params).then(
        (response) => {
          that.handleCancelGptQueueResponse(response);
        },
        (error) => {
          console.error(error);
        }
      );
    },
    handleCancelGptQueueResponse(response) {
      if (response.data.Code == 0) {
        //
        this.currentGptQueue = null;
      } else {
        this.$message.error(response.data.Description);
      }
    },
    onClickThumbUp(message) {
      if (this.isScored(message)) {
        return;
      }
      this.$message.success(i18n.t("ppt_add_in_main.text_like"))
      this.scoreAnswer(message);
    },
    onClickThumbDown(message) {
      if (this.isScored(message)) {
        return;
      }
      this.scoreAnswer(message);
    },
    scoreAnswer(message) {
      // let params = {
      //   talkId: this.gptTalk.Id,
      //   messageId: message.Id,
      //   score: score,
      // };
      // var that = this;
      this.addToScoringQueue(message);
      //临时逻辑，等接口修复好之后再接入正确的逻辑
      message["Score"] = 80;
      this.removeFromScoringQueue(message);
      // this.$message.error(this.$t("common.operation_succeed"));
      return
      // wd_scoreAnswer(params).then(
      //   (res) => {
      //     that.handleScoreAnswerResponse(message, params, res);
      //   },
      //   (err) => {
      //     console.log(err);
      //   }
      // );
    },
    handleScoreAnswerResponse(message, requestParams, res) {
      if (res.data.Code == 0) {
        message["Score"] = requestParams.score;
        this.removeFromScoringQueue(message);
      }
    },
    addToScoringQueue(message) {
      if (!this.isInScoringQueue(message)) {
        this.scoringQueue.push(message);
      }
    },
    removeFromScoringQueue(message) {
      for (let i = 0; i < this.scoringQueue.length; i++) {
        let queueMessage = this.scoringQueue[i];
        if (isEqualGuidString(message.Id, queueMessage.Id)) {
          this.scoringQueue.splice(i, 1);
          break;
        }
      }
    },
    isInScoringQueue(message) {
      let inQueue = false;
      for (let i = 0; i < this.scoringQueue.length; i++) {
        let queueMessage = this.scoringQueue[i];
        if (isEqualGuidString(message.Id, queueMessage.Id)) {
          inQueue = true;
          break;
        }
      }
      return inQueue;
    },
    formatMessage(isSelfMsg, content) {
      if (isSelfMsg) {
        content = lineBreakSymbol(content);
      }
      // 如果文本中是 JSON 传过来的双转义 \\n，先变成真正的 \n
      content = content.replace(/\\n/g, '\n');

      // 1. 提取多行代码块
      const codeBlocks = [];
      content = content.replace(/```(\w*)[ \t]*(?:\r\n|\r|\n)([\s\S]*?)```/g, (match, lang, code) => {
        codeBlocks.push({ lang, code });
        return `@@CODEBLOCK${codeBlocks.length - 1}@@`;
      });

      // 2. 先做基本 HTML 转义，防止用户直接写 <script> 等
      content = content
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;");

      // 3. 转换标题（先转换二级标题，再一级标题）
      content = content
        .replace(/^###### (.+)$/gm, '<h6>$1</h6>')
        .replace(/^##### (.+)$/gm, '<h5>$1</h5>')
        .replace(/^#### (.+)$/gm, '<h4>$1</h4>')
        .replace(/^### (.+)$/gm, '<h3>$1</h3>')
        .replace(/^## (.+)$/gm, '<h2>$1</h2>')
        .replace(/^# (.+)$/gm, '<h1>$1</h1>');

      // 4. 转换加粗、斜体、内联代码（内联代码用单反引号）
      content = content
        .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
        .replace(/\*([^*]+)\*/g, '<em>$1</em>')
        .replace(/`([^`]+)`/g, '<code>$1</code>');

      // 5. 转换 Markdown 图片和链接
      content = content.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g,
        '<img src="$2" alt="$1" style="max-width:100%;">');

      content = content.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g,
        '<a href="$2" target="_blank">$1</a>');

      // 6. 无序列表项
      content = content.replace(/^[-•] (.+)$/gm, '<li>$1</li>');

      // 7. 有序列表（如 1. xxx）只保留文本，不生成列表结构
      content = content.replace(/^(\d+)\. (.+)$/gm, '$1. $2');

      // 8. 包裹 <ul>
      content = content.replace(/(<li>(?:.*?<\/li>)(?:\n<li>.*?<\/li>)*)/gs, (match) => {
        return `<ul style="line-height:1.5">${match.replace(/\n/g, '')}</ul>`;
      });

      // 9. 处理换行：用 <p> 包裹段落
      const paragraphs = content.split(/\n{2,}/).filter(p => p.trim() !== '');
      content = paragraphs.map(p => {
        if (/^<(ul|ol|div)/.test(p.trim())) {
          return p.trim();
        }
        return `<p style="line-height:1.6">${p.replace(/\n/g, '<br>')}</p>`;
      }).join('');

      // 再保险，移除 ol|ul|div 后面多余的 <br>
      content = content.replace(/(<\/(ul|div)>)<br>/g, '$1');

      // 10. 恢复之前保存的多行代码块内容，替换占位符
      content = content.replace(/@@CODEBLOCK(\d+)@@/g, (_, idx) => {
        const block = codeBlocks[idx];
        const escapedCode = block.code
          .replace(/&/g, '&amp;')
          .replace(/</g, '&lt;')
          .replace(/>/g, '&gt;');
        
        const blockId = `code-block-${Date.now()}-${idx}`;
        
        return `
          <div class="code-block-wrapper">
            <pre data-lang="${block.lang ? block.lang : '文本块'}"><code class="language-${block.lang}" id="${blockId}">${escapedCode}</code></pre>
          </div>
        `;
      });

      return content;
    },
    copyCode(blockId, buttonEl) {
      const codeElement = document.getElementById(blockId);
      const text = codeElement.textContent;

      navigator.clipboard.writeText(text).then(() => {
        const originalText = buttonEl.textContent;
        buttonEl.textContent = '已复制!';
        setTimeout(() => {
          buttonEl.textContent = originalText;
        }, 2000);
      }).catch(err => {
        console.error('复制失败:', err);
      });
    },
    previewImg(imgUrl) {
      window.open(imgUrl)
    },
    copy(message) {
      //创建input标签
      var input = document.createElement("textarea");
      //将input的值设置为需要复制的内容
      let reg1 = new RegExp("<br/>", "g");
      let center = message.replace(reg1, "\n");
      input.value = center;
      //添加input标签
      document.body.appendChild(input);
      //选中input标签
      input.select();
      //执行复制
      document.execCommand("copy");
      //移除input标签
      document.body.removeChild(input);
      this.$message.success(i18n.t("ppt_add_in_main.text_copy_success"))
    },
    copyImage(imageUrl) {
      // try {  
      //   // 获取图片元素  
      //   const img = document.getElementById('image');  
      //   // 创建一个 canvas 元素  
      //   const canvas = document.createElement('canvas');  
      //   canvas.width = img.width;  
      //   canvas.height = img.height;  
      //   // 将图片绘制到 canvas 上  
      //   const context = canvas.getContext('2d');  
      //   context.drawImage(img, 0, 0, img.width, img.height);  
      //   // 将 canvas 转换为 Blob  
      //   canvas.toBlob(async (blob) => {  
      //     // 创建一个 ClipboardItem  
      //     const item = new ClipboardItem({ 'image/png': blob });  
      //     // 写入剪贴板  
      //     await navigator.clipboard.write([item]);  
      //   });  
      // } catch (err) {  
      //   console.error('Failed to copy image: ', err);  
      // } 
      // try {  
      //   // const response = await ;  
      //   const blob = fetch(imageUrl).blob();  

      //   const item = new ClipboardItem({ [blob.type]: blob });  
      //   await navigator.clipboard.write([item]);  
      //   alert('Image copied to clipboard!');  
      // } catch (err) {  
      //   console.error('Failed to copy image: ', err);  
      // }   
    },
    clearSelectTask() {
      store.set("gpt/selectedTaskType", null);
      store.set("gpt/selectedTaskOptions", null);

      store.set("gpt/hideAutoActionType", true);
      store.set("gpt/autoActionTypeFirst", null);
      store.set("gpt/autoActionTypeSecond", null);
      store.set("gpt/autoActionType", null)
    },
    updateTaskStatusofWholeTemplateSlides() {
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", { 
          id: "taskType_semantic_whole_template_ppt", 
          title: i18n.t("ppt_menus.ppt_menus_full_template_ppt")
        });
      store.set("gpt/selectedTaskOptions", {
          id: "ppt_option_menu_textonly",
          title: "纯文字",
        });
    },
    updateTaskStatusofWholeSlides() {
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", { 
          id: "task_all_normal", 
          title: i18n.t("ppt_menus.ppt_menus_full_ppt")
        });
      store.set("gpt/selectedTaskOptions", {
          id: "ppt_option_menu_textonly",
          title: "纯文字",
        });
    },
    updateTaskStatusofOnePage() {
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", {
          id: "task_one_page_general",
          title: i18n.t("ppt_menus.ppt_menus_one_page"),
          template_id: "template_one_page_general",
        });
    },
    updateTaskStatusofOutline() {
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", {
          id: "taskType_outline",
          title: i18n.t("ppt_menus.ppt_menus_ppt_outline"),
          hasSubMenus: false,
        });
      // this.showOutlineDialog()
    },
    updateTaskStatusofSlidesfromFiile() {
      this.clearSelectTask()
      this.$refs.refFileInput[0].click()
      store.set("gpt/selectedTaskType", {
          id: "taskType_ppt_from_file",
          // title: "从文件创建PPT",
          title: i18n.t("ppt_menus.ppt_menus_file_to_ppt"),
          hasSubMenus: false,
        })
    },
    reCreatePPT(msg){
      this.sseMessageId = msg.Id
      createWholePPT(lineBreakSymbol(msg.Text))
    },
    reCreateOnePageSlide(msg) {
      this.onPageSlideTextString = ''
      if (this.isOnePageTemplateSlide(msg)) {
        let textJson = []
        try {
          textJson = JSON.parse(removeBeforeFirstBracket(clearLineBreakSymbol(clearNotJsonBreakSymbol(msg.Text))))
        } catch (error) {
          console.log('reCreateOnePageSlide.error:', error)
        }
        for (let i = 0; i < textJson.length; i++) {
          this.onPageSlideTextString += textJson[i].SC + '\n'
        }
      } else {
        this.onPageSlideTextString = lineBreakSymbol(msg.Text)
      }
      this.onPageSlideTextString = this.onPageSlideTextString.replace(/\*\*\*|###/g, '')
      localStorage.setItem(userKeys.key_user_generate_slide_is_change_one_page_template, JSON.stringify(true))
      this.updateTaskStatusofOnePage()
      publish(actionMenuPubIds.pubId_Action_Menu_Click_Change_OnePage_Template, {})
    },
    handleFileChange(e) {
      this.selectFile = e.target.files[0]
      if (this.selectFile) {
        this.upLoadFile()
      }
    },
    upLoadFile() {
      publish(
        aisaPubIds.pubId_Action_Menu_PPT_From_File_Upload, 
        { 
          loadinText: i18n.t("ppt_add_in_main.input_bar_placeholder_uploading_first") 
          + this.selectFile.name +
          i18n.t("ppt_add_in_main.input_bar_placeholder_uploading_second") 
        }
      );
      var formData = new FormData();
      formData.append("attachmentFile", this.selectFile);
      api_upload_file(formData).then(
        (response) => {
          if (response.data.Code == 0) {
            publish(
              aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, 
              { 
                loadinText: i18n.t("ppt_add_in_main.input_bar_placeholder_after_upload_file_first") 
                + this.selectFile.name +
                i18n.t("ppt_add_in_main.input_bar_placeholder_after_upload_file_second"), fileName: this.selectFile.name, selectFileId: response.data.Result.FileMD5 
              }
            );
            this.selectFileId = response.data.Result.FileMD5
          } else {
            publish(aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, {});
            this.$message.warning(response.data.Description)
          }
        },
        (error) => {
          publish(aisaPubIds.pubId_Action_Menu_PPT_From_File_Finish, {});
          console.error(error);
        }
      );
    },
    closeSlideOutline() {
      this.hideOutlineDialog()
      this.clearSelectTask()
      this.scrollToBottom()
    },
    reGenerateOutline() {
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", {
          id: "taskType_outline_optimize",
          title: i18n.t("ppt_menus.ppt_menus_refine_outline"),
          hasSubMenus: false,
        });
      this.isOutlineOptimizeLoading = true
      publish(gptPubIds.pubId_Local_Gpt_ProcessingText, i18n.t("ppt_addin.process.text_ppt_generating_content"))
      this.judgeInputIsTask(this.outlineOptimize.demandText)
    },
    generateOutlinePPT(outlineContent) {
      this.outlineOptimize.resourceContent = convertLineBreakSymbolReverse(lineBreakSymbol(outlineContent))
      this.clearSelectTask()
      store.set("gpt/selectedTaskType", {
          id: "taskType_outline_ppt",
          title: i18n.t("ppt_menus.ppt_menus_outline_to_ppt"),
          hasSubMenus: false,
        });
      this.hideOutlineDialog()
      this.judgeInputIsTask(i18n.t("ppt_action_type.suggest_action_generate_ppt_outline"))
      publish(aisaPubIds.pubId_Local_Aisa_AskGpt_Generating, "")
    },
    outlineArrGoback() {
      if (this.currentOutlineIndex > 1) {
        this.currentOutlineIndex -= 1
      } else if (this.currentOutlineIndex == 1) {
        this.currentOutlineIndex = this.outlineContentArr.length
      }
      this.outlineOptimize.resourceContent = this.outlineContentArr[this.currentOutlineIndex - 1]
    },
    outlineArrGonext() {
      if (this.currentOutlineIndex < this.outlineContentArr.length) {
        this.currentOutlineIndex += 1
      } else if (this.currentOutlineIndex == this.outlineContentArr.length) {
        this.currentOutlineIndex = 1
      }
      this.outlineOptimize.resourceContent = this.outlineContentArr[this.currentOutlineIndex - 1]
    },
    goback() {
      window.history.back()
    },
    insertImage(imgUrl) {
      let options = {
        coercionType: Office.CoercionType.Image,
        imageLeft: 480,
        imageTop: 70,
        imageWidth: 400,
        imageHeight: 400,
      };
      insertImageByCompletionUrl(imgUrl, options)
    },
    insert(content) {
      getCurrentSelectState((currentState) => {
        let slideState = currentState.selectSlide.state
        let shapeState = currentState.selectShape.state
        if (slideState == i18n.t("ppt_select_state.select_one_slide")) {
          switch (shapeState) {
            case i18n.t("ppt_select_state.select_no_shape"):
            case i18n.t("ppt_select_state.select_mluti_shapes"):
              // to 根据当前内容插入一个新的文本框
              insertTextShape(convertLineBreakSymbolReverse(convertLineBreakSymbol(content)))
              break;
            case i18n.t("ppt_select_state.select_one_shape"):
              // to 在当前shape内容后插入内容
              addContentforSelectShape(convertLineBreakSymbolReverse(convertLineBreakSymbol(content)))
              break;
            default:
              break;
          }
        } else {
          // todo 选中多个slides的时候，直接根据当前内容插入一页新的slide
        }
      })
    },
    optimize(content, isOptimizeGenerate) {
      var params = {
        title: "",
        placeholder: i18n.t("home.text_general_placeholder"),
        inputText: "",
        type: "",
        content: "",
        isLoading: false,
        isSelected: false,
        isFinishGenerate: false,
        generateContent: convertLineBreakSymbolReverse(convertLineBreakSymbol(content)),
        warringText: i18n.t("home.text_general_warring_text"),
        isOptimizeGenerate: isOptimizeGenerate
      }

      this.$router.push({
        path: "/optimize",
        query: params
      });
    },
    // 注意，这里参数中的fileName就是自定义的属性，随机生成的UUID，每个文档只会生成一次
    queryFileTalkId(fileName, content) {
      var params = {
        FileName: fileName,
        Content: content
      };
      api_create_document_agent_user(params).then(
        (response) => {
          this.handleDocumentAgentUserResponse(response);
        },
        (error) => {
          this.handleChatGPTOpenAIError(error);
        }
      );
    },
    handleDocumentAgentUserResponse(response) {
      if (response.data != null && response.data.Code == 0 && response.data.Result != null) {
        addAgentUserId(response.data.Result.UserId)
        localStorage.setItem("AgentUserId", response.data.Result.UserId)
        this.queryGptTalk();
      } else {
        this.isLoadingData = false
        //todo need a dialog to show error
      }
    },
    handleChatGPTOpenAIError(error) {
      this.isLoadingData = false
      console.log(error);
      //todo need a dialog to show error
    },
    upgrade() {
      this.$router.push('/subscriptions?tab=buy-subscriptions');
    },
    // getServiceAvatar() {
    //   return getServiceWindowAvatar(wdConfigData.gtpCoverId);
    // }
    adjustHeight() {
      const maxHeight = window.innerHeight // 当前可视区高度  
      this.rows = Math.ceil((maxHeight - 350) / 30) // 求出当前输入框最优行数
    },
    // Pubsub
    pubCallback(msgName, data) {
      if (msgName == actionMenuPubIds.pubId_Action_Menu_Whole_Template_PPT) {
        this.updateTaskStatusofWholeTemplateSlides()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_Whole_PPT) {
        this.updateTaskStatusofWholeSlides()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_One_Page_PPT) {
        this.updateTaskStatusofOnePage()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_Outline_PPT) {
        this.updateTaskStatusofOutline()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_PPT_From_File) {
        // 去选择文件
        this.updateTaskStatusofSlidesfromFiile()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_PPT_From_File_header_action) {
        // header 选择了文件生成的模板
        if (data) {
          this.selectFile = data
        }
        this.upLoadFile()
      } else if (msgName == actionMenuPubIds.pubId_Action_Menu_clear_action) {
        this.selectFile = ""
      } else if (msgName == gptPubIds.pubId_Local_Gpt_ProcessingText) {
        if (this.messageList.find(item => item.Id === this.sseMessageId)) {
          if (data.totalCount != data.currentIndex) {
            this.messageList.find(item => item.Id === this.sseMessageId).ViewText = data.txt
          } else {
            this.messageList.find(item => item.Id === this.sseMessageId).ViewText = data.txt + '\\n' + i18n.t('ppt_addin.process.text_msg_complete_allSlides_generate')
            this.scrollToBottom()
          }
        }
      }
    },
    getorAddFileCopilotId() {
      getOrAddCopilotId((copilotID) => {
        if (copilotID) {
          // 获取/配置参数成功，先不判断获取当前文档内容是否成功，先继续流程
          getAllSlideText((content) => {
            this.queryFileTalkId(copilotID, content)
          },
          (error) => {
            this.queryFileTalkId(copilotID, content)
          })
        } else {
          console.log("getOrAddCopilotId filure: " + error);
          this.isLoadingData = false
          this.$message.warning(i18n.t("ppt_add_in_main.paramter_error"))
        }
      }, 
      (error) => {
        console.log("getOrAddCopilotId filure: " + error);
        this.isLoadingData = false
        this.$message.warning(i18n.t("ppt_add_in_main.paramter_error"))
      })
    },
  },
  //生命周期-创建完成(可以访问当前this实例)
  created() {
    var user = JSON.parse(localStorage.getItem(userKeys.key_userObject));
    this.currentUser = user;
  },
  //生命周期-挂载完成(可以访问DOM元素)
  mounted() {
    i18n.locale = wdConfigData.localLanguage
    if (i18n.locale == "zhHans") {
      this.ImageStyle = aiMenusZh.state.ImageStyle
      this.ImageMode = aiMenusZh.state.ImageMode
    } else {
      this.ImageStyle = aiMenusEn.state.ImageStyle
      this.ImageMode = aiMenusEn.state.ImageMode
    }
    window.addEventListener('resize', this.adjustHeight);
    this.adjustHeight();

    subscribe(actionMenuPubIds.pubId_Action_Menu_Whole_Template_PPT, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_Whole_PPT, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_One_Page_PPT, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_Outline_PPT, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_PPT_From_File, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_PPT_From_File_header_action, this.pubCallback)
    subscribe(actionMenuPubIds.pubId_Action_Menu_clear_action, this.pubCallback)
    subscribe(gptPubIds.pubId_Local_Gpt_ProcessingText, this.pubCallback);

    // for demo
    this.imageHubUrl = `${localStorage.getItem(userKeys.key_serviceUrl_ImageHub)}/F5E30CF7-27B2-1DB7-A4E6-E2C2704E8A3C`
    // this.imageHubUrl = `https://localhost:3000/ih/c0487c7f88984f11/F5E30CF7-27B2-1DB7-A4E6-E2C2704E8A3C`
    
    // 委托监听所有复制按钮
    this.$refs.refChatPS.$el.addEventListener('click', (e) => {
      if (e.target.classList.contains('copy-btn')) {
        const blockId = e.target.getAttribute('data-block-id');
        this.copyCode(blockId, e.target);
      }
    });
    
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.adjustHeight)
  },
  destroyed() {
    unsubscribe(this.pubCallback);
  }, //生命周期-销毁完成
  activated() {
    this.isLoadingData = true
    this.chatLoadingText = i18n.t("chat.chat_document_init_loading")
    getAgentUserId((agentUserId) => {
        console.log("getAgentUserId: " + agentUserId);
        if (agentUserId) {
          localStorage.setItem("AgentUserId", agentUserId)
          this.queryGptTalk();
        } else {
          this.getorAddFileCopilotId()
        }
      },
      (error) => {
        console.log("getAgentUserId filure: " + error);
        this.getorAddFileCopilotId()
      }
    )
  }, //如果页面有keep-alive,这函数会触发
};
</script>
<style lang="scss">
.card {
  width: 100%;
  margin-top: 10px;
  display: inline-block;
  align-items: center;
  justify-content: space-between;
  background-color: white;
  //border: 2px solid rgba(0, 0, 0, 0.1);  
  border-radius: 10px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
  padding: 0px 6px 5px 6px;
}

.generatebtn {
  height: 22px;
  width: 200px;
  line-height: 20px;
  background-color: rgb(22, 110, 210);
  /* border:1px solid #cecece; */
  color: #ffffff;
  font-size: 16px;
  padding: 0 2px;
  display: flex;
  align-items: center;
  /* 垂直居中 */
  justify-content: center;
  /* 水平居中 */
  border-radius: 6px;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2), 0 1px 5px 0 rgba(0, 0, 0, 0.19);
  ;
}

.v-application p {
  margin-bottom: 5px !important;
}

.v-application .ml-8 {
  margin-left: 19px !important;
}

.islink {
  color: #2196f3;
}

.loading-text {
  font-size: 13px;
  display: inline-flex;
  align-items: center;
  
  .dot-flashing {
    position: relative;
    width: 30px;
    height: 13px;
    
    &::before,
    &::after {
      content: "";
      display: inline-block;
      position: absolute;
      width: 4px;
      height: 4px;
      border-radius: 50%;
      background-color: currentColor;
      animation: dotFlashing 0.5s infinite alternate;
    }
    
    &::before {
      left: 5px;
      animation-delay: 0s;
    }
    
    &::after {
      left: 15px;
      animation-delay: 0.1s;
    }
  }
}

@keyframes dotFlashing {
  0% {
    opacity: 0.3;
    transform: translateY(5px);
  }
  100% {
    opacity: 1;
    transform: translateY(0);
  }
}

.blinkCursor {
  font-weight: bold;
  animation: Blink 1s ease-in 0s infinite;
  padding-left: 3px;
  font-size: 13px
}

@keyframes Blink {
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
}
</style>
